import { render, staticRenderFns } from "./CtaSection.vue?vue&type=template&id=f35f90ee&scoped=true"
import script from "./CtaSection.vue?vue&type=script&lang=js"
export * from "./CtaSection.vue?vue&type=script&lang=js"
import style0 from "./CtaSection.vue?vue&type=style&index=0&id=f35f90ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35f90ee",
  null
  
)

export default component.exports